'use client';
import { Flex, Image } from 'antd';
import cn from 'classnames';
import { useRouter } from 'next/navigation';
import CustButton, { GeneralButtonType } from '../Button';
import { useGlobalStore } from '@/hooks/useGlobalStore';
import { WATrackerClickEvn, getButtonLinkWithCID } from '@/utils/wa';
import RichText from '../RichText';
import { withFullPath } from '@/utils/utils';
import Heading from '../Heading';

/** 适用于 parties-PartyCardList  */
const PartyCardList = (props: { data: any; type?: string }) => {
    // console.log('list---', props);
    const router = useRouter();
    const list = props.data;

    const globalStore = useGlobalStore();
    const currentTheme = globalStore.currentTheme;

    const handleItemClick = () => {
        WATrackerClickEvn(`RnE/HW_ClickBanner_Section-Banner-${props.type || ''}`);
        router.push(
            `/${globalStore.lang}${
                getButtonLinkWithCID(
                    list.ctaButtonUrl?.value,
                    `Party/Home/schedule_Section-Banner-${props.type || ''}`,
                ) || ''
            }`,
        );
    };

    return (
        <Flex vertical className='h-full cursor-pointer' onClick={handleItemClick}>
            {list.partyImage?.src && (
                <Image
                    className='aspect-[4/3] rounded-t-[5px] object-cover'
                    // width={422}
                    // height={316}
                    preview={false}
                    src={withFullPath(list.partyImage?.src)}
                    alt=''
                />
            )}
            <Flex
                vertical
                className={cn('pt-6 pb-8 px-5 bg-[#0D263E] flex-grow gap-4 rounded-b-[5px]')}
            >
                <Heading level={4} text={list.partyName?.value} />
                <Heading
                    level={5}
                    text={list.partyDateText?.value}
                    className={'text-black bg-[#EAE219] w-fit px-2 py-[2px]'}
                    style={{ background: currentTheme?.themeColor, color: currentTheme?.fontColor }}
                />
            </Flex>
        </Flex>
    );
};

export default PartyCardList;
